import { Env } from '../Models/Env';


export class EnvDetector
{
    public get Env(): Env
    {
        if (window.location.origin.includes("localhost"))
            return Env.Local;
        else if (window.location.origin.includes("stage"))
            return Env.Stage;

        else
            return Env.Prod;
    }

    constructor()
    {
        console.log(`Assuming environment is ${this.Env}`);
    }
}
